module.exports = __webpack_public_path__ + "static/media/Sertifikat.f4b4ee96.svg";